import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import classes from "./termsAndConditionsDetailPage.module.css";

import {
  useDeleteTermsAndConditionsMutation,
  useGetTermsAndConditionsByIdQuery,
  useUpdateTermsAndConditionsMutation,
} from "../../../services/termsAndConditions/termsAndConditionsApiSlice";
import { useGetTermsAndConditionsMenuQuery } from "../../../services/termsAndConditions/termsAndConditionsMenuApiSlice";

import { TermsAndConditionsDetail } from "../../../component/termsAndConditions/TermsAndConditionsDetail";

export const TermsAndConditionsDetailPage = () => {
  const { termsAndConditionsId } = useParams();
  const navigate = useNavigate();

  const { data: termsData, isLoading } = useGetTermsAndConditionsByIdQuery(
    termsAndConditionsId,
    { skip: !termsAndConditionsId }
  );

  const { data: categoryItems = [], isLoading: isMenuLoading } =
    useGetTermsAndConditionsMenuQuery();

  const [updateTerms] = useUpdateTermsAndConditionsMutation();
  const [deleteTerms] = useDeleteTermsAndConditionsMutation();

  /* ---------- Update ---------- */

  const handleSubmit = async (formData) => {
    await toast.promise(
      updateTerms({
        id: termsAndConditionsId,
        body: formData,
      }).unwrap(),
      {
        pending: "Updating terms and conditions...",
        success: "Updated successfully!",
        error: {
          render({ data }) {
            return data?.data?.message || "Update failed.";
          },
        },
      }
    );

    navigate("/terms_and_conditions");
  };

  /* ---------- Delete ---------- */

  const handleDelete = async () => {
    await toast.promise(
      deleteTerms(termsAndConditionsId).unwrap(),
      {
        pending: "Deleting terms and conditions...",
        success: "Deleted successfully!",
        error: {
          render({ data }) {
            return data?.data?.message || "Delete failed.";
          },
        },
      }
    );

    navigate("/terms_and_conditions");
  };

  if (isLoading || isMenuLoading) return null;

  return (
    <div className={classes.wrapper}>
      <h2 className={classes.pageTitle}>
        Edit Terms And Conditions
      </h2>

      <TermsAndConditionsDetail
        initialValues={termsData}
        categoryItems={categoryItems}
        onSubmit={handleSubmit}
        onDelete={handleDelete}
      />
    </div>
  );
};